import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { StoryPageBody } from "../components/StoryPageBody";

export const Template = (
    props: Immutable<templates.StoryPageTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <StoryPageBody mattress_url={props.mattress_url} />
    </PageSkeleton>
);
